"use strict";
// Copyright © 2021 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarqueeText = void 0;
const vue_1 = __importDefault(require("vue"));
/**
 * @author EvodiaAut <evodia.aut@gmail.com>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 *
 * @see https://github.com/EvodiaAut/vue-marquee-text-component
 */
exports.MarqueeText = vue_1.default.extend({
    name: 'MarqueeText',
    functional: true,
    props: {
        duration: {
            type: Number,
            default: 15
        },
        repeat: {
            type: Number,
            default: 2,
            validator: function (val) {
                return val > 0;
            }
        },
        paused: {
            type: Boolean,
            default: false
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    render(h, { props: { duration, repeat, paused, reverse }, children, data: { staticClass, key, on } }) {
        const text = h('div', {
            class: 'text',
            style: {
                animationDuration: `${duration}s`,
                animationDirection: reverse ? 'reverse' : undefined
            }
        }, children);
        return h('div', {
            key,
            on,
            class: [
                staticClass,
                'wrap'
            ]
        }, [
            h('div', {
                class: [
                    paused ? 'paused' : undefined,
                    'content'
                ]
            }, Array(repeat).fill(text))
        ]);
    }
});
//# sourceMappingURL=MarqueeText.js.map